import React from 'react'

function Error() {
  return (
    <>
    <h2>Something went Wrong</h2>
    <img src="../../../../images/maintenance.png"/>
    </>
  )
}

export default Error